<template>
  <v-app class="app">
    <!-- assistant 的 header 預留空間 -->
    <!-- <div class="blank-area" v-if="!appbar.fixed" :style="style_height"></div> -->
    <div class="app-header" :style="style_appbar">
      <app-bar v-show="showAppBar">
      </app-bar>
    </div>
    <app-bar-drawer v-if="enableAppDrawer"></app-bar-drawer>
    <!-- <div class="blank-area d-inline-flex" v-if="appbar.fixed" :style="style_height"></div> -->
    <v-content style="padding-top: 0px;">
      <div class="main-content" :style="style_mainContent">
        <router-view />
      </div>
    </v-content>
  </v-app>
</template>

<script>
import AppBar from '@/components/AppBar'
import AppBarDrawer from '@/components/AppBarDrawer'

export default {
  name: 'App',

  components: {
    AppBar,
    AppBarDrawer
  },
  computed: {
    appbar(){
      return this.$store.state.appbar
    },
    topMargin(){
      return this.$store.state.topMargin
    },
    assistantHeaderHeight(){
      return this.$store.state.assistantHeaderHeight
    },
    showAppBar(){
      return !this.$store.state.appbar.disabled
    },
    enableAppDrawer(){
      return this.$store.state.appbar.drawer.toggleBtn
    },
    style_appbar(){
      return {
        paddingTop: `${this.assistantHeaderHeight}px`
      }
    },
    style_height(){
      return {
        height: `${this.topMargin}px`
      }
    },
    style_mainContent(){
      return {
        // minHeight: `calc(100vh - ${this.topMargin}px)`,
        height: `calc(100vh - ${this.assistantHeaderHeight + 48}px)`
      }
    }
  },
  data: () => ({
  }),
  created(){
    // let url = new URL(location.href)
    // console.log('url', url)
  },
  mounted(){
    console.log('App: mounted')
    // console.log('$route', this.$route.query)
    // this.$nextTick(()=>{
    //   console.log('$route2', this.$route.query)
    // })
    // debug用
    if(process.env.NODE_ENV === 'development'){
      window.$route = this.$route
      window.$router = this.$router
      window.i18n = this.$i18n
    }
    this.$store.commit('appbar/toggle', true)
    this.$store.dispatch('user/sync')
    this.checkActionMode()
    this.windowSizeCheck()
    window.addEventListener('resize', this.windowSizeCheck.bind(this), { passive: true })

    // 在 action 中開啟網頁時用history模式會有問題
    // 所以所有頁面設計成若在 assistant 中開啟會自動切換為abstract模式
    // 並且跳至對應葉面
    if(this.$router.mode === 'abstract'){
      console.debug(`abstract mode => ${location.pathname + location.search + location.hash}`)
      this.$router.replace(location.pathname + location.search + location.hash, ()=>{
        this.checkActionMode()
      })
    }
  },
  methods: {
    checkActionMode(){
      console.log('App.checkActionMode', this.$route.query, this.$route.query.actionMode && this.$route.query.actionMode !== 'false')
      if(this.$route.query.actionMode && this.$route.query.actionMode !== 'false'){
        this.$store.commit('enableActionMode')
        require('@/lib/Assistant').instance.getHeaderHeightPx().then((height)=>{
          this.$store.commit('setAssistantHeaderHeight', height)
          this.$store.commit('updateTopMargin')
        })
      }
    },
    windowSizeCheck(){
      // console.log(window.outerWidth, window.outerWidth !== this.$lastWidth)
      if(window.outerWidth !== this.$lastWidth){
        if(this.$timer){
          clearTimeout(this.$timer)
          this.$timer = null
        }
        this.$lastWidth = window.outerWidth
        this.$timer = setTimeout(()=>{
          this.$bus.$emit('window-resize')
        }, 200)
      }
    }
  }
}
</script>
<style>
  html{
    /* overflow-y: auto !important; */
  }
  html,body{
    background-color: #15202b;
    color: white;
  }
  #resources{
  }
  #app{
    font-family: Microsoft JhengHei, sans-serif;
  }
  .main-content{
    /* margin-top: -10px; */
  }
  .blank-area{
    width: 100%;
  }
  .v-btn.v-size--x-large{
    font-size: 1.7em !important;
  }
  ::-webkit-scrollbar {
    width: 12px;
  }
  ::-webkit-scrollbar-track {
    width: 12px;
    background-color: rgba(100, 100, 100, 0.3);
  }
  ::-webkit-scrollbar-thumb {
    background-color: rgba(150,150,150,0.3);
  }
  /* .v-content__wrap>.main-content{
    position: relative;
    top: -24px;
  } */
</style>
